// extracted by mini-css-extract-plugin
export default {"widgets":"widgets--ObVHZ"};